// extracted by mini-css-extract-plugin
export var dropdown = "_t8-0";
export var imageWrapper = "_t8-3";
export var itemNameContainer = "_t8-1";
export var productImage = "_t8-2";
export var spinnerWrapper = "_t8-4";